<script lang="ts" setup="">
import { useSidebar } from '@/composables/useSidebar'
import { NProductSwitcher, type StudyHubPage } from '@novonordisk/studyhub-insights'
import { SideBarNavInjectedPropsSymbol } from '@novonordisk/studyhub-novoui/vue'
import { provide } from 'vue'

defineProps<{
  currentPage?: StudyHubPage
}>()

const { collapsed } = useSidebar()

// Apparently this entire Product Switcher is centered around a cryptic provide/inject pattern
provide(SideBarNavInjectedPropsSymbol, {
  collapsed,
})
</script>

<template>
  <aside
    class="ease border-general-medium bg-general-base fixed top-0 left-0 z-40 flex h-screen flex-col gap-6 border-r p-4 transition-[width] duration-150"
    :class="{
      'w-[72px]': collapsed,
      'w-64': !collapsed,
      'transition-delay-150': !collapsed,
      'transition-delay-300': collapsed,
    }"
  >
    <NProductSwitcher :current-page="currentPage" />
    <VDivider />
    <div class="flex-1">
      <slot
        name="menu"
        :collapsed="collapsed"
      />
    </div>
    <div>
      <slot
        name="footer"
        :collapsed="collapsed"
      />
    </div>
    <VDivider />
    <div>
      <slot
        name="collapse"
        :collapsed="collapsed"
      >
        <VSidebarNavItem
          :icon="collapsed ? 'panelOpen' : 'panelClose'"
          :label="collapsed ? 'Expand menu' : 'Collapse menu'"
          :collapsed
          @click="collapsed = !collapsed"
        />
      </slot>
    </div>
  </aside>
  <main
    class="ease flex-1 overflow-auto transition-all duration-150"
    :class="{
      'ml-16': collapsed,
      'ml-64': !collapsed,
      'transition-delay-150': !collapsed,
      'transition-delay-300': collapsed,
    }"
  >
    <slot />
  </main>
</template>

<style>
.transition-delay-150 {
  transition-delay: 150ms;
}

.transition-delay-300 {
  transition-delay: 300ms;
}

.session-selector-dropdown.dropdown {
  width: 224px !important;
}

.session-selector-wrapper {
  margin: 0;
}
</style>
